import { IonItem } from "@ionic/react";
import React, { useEffect } from "react";
import { RouteProps } from "react-router";
import { hapticsImpactMedium } from "../../../utils/core-utils/hapticUtils";
import { CMEDPermissions } from "../MarketData/MarketDataContent";
import { useAppPref } from "../../../components/providers/AppPrefProvider";

interface OptionsGridListItemProps extends RouteProps {
  optionGridData: any;
  userCMEDEntitlements: CMEDPermissions | undefined;
  setIsOptionsGridViewModalOpen: Function;
  setSelectedStrike: Function;
  setOrderEntryData: any;
  orderAggressionCall: any;
  setorderAggressionCall: any;
  orderAggressionPut: any;
  setorderAggressionPut: any;
  setSelectedOption: any;
  setopenOrderAggressionModal: any;
  index: any;
  setOrderEntryData_Live: any;
  orderEntryData: any;
  setOpenOrderEntryModal: Function;
  setOrderEntryType: Function;
  setType: Function;
  selectedDerivativeType: string;
  greeksData: any;
  strikePriceATM: any;
  nearestStrike: any;
}

const OptionsGridListItem: React.FC<OptionsGridListItemProps> = ({
  userCMEDEntitlements,
  optionGridData,
  setIsOptionsGridViewModalOpen,
  setSelectedStrike,
  setOrderEntryData,
  setSelectedOption,
  setopenOrderAggressionModal,
  index,
  setOrderEntryData_Live,
  orderEntryData,
  setOpenOrderEntryModal,
  setOrderEntryType,
  setType,
  selectedDerivativeType,
  greeksData,
  strikePriceATM,
  nearestStrike,
}) => {
  const { setIsOrderEntryOpenedFromMain } = useAppPref();
  useEffect(() => {
    if (orderEntryData?.i === optionGridData?.i) {
      setOrderEntryData_Live(optionGridData);
    }
  }, [optionGridData]);

  // Aggressive order function
  const orderAegressionIndicator = (
    type: any,
    isAggresiveModeOn: any,
    orderType: any,
  ) => {
    if (isAggresiveModeOn) {
      if (type === "bid") {
        setOrderEntryType("offer");
      } else if (type === "offer") {
        setOrderEntryType("bid");
      }
    } else setOrderEntryType(type);
    setType(orderType);
  };

  //bid and offer modal details
  const bidAndOfferModalDetail = (type: any, orderType: any) => {
    setSelectedOption(optionGridData);
    hapticsImpactMedium();
    setopenOrderAggressionModal(true);
    setOpenOrderEntryModal(true);
    orderAegressionIndicator(
      type,
      userCMEDEntitlements?.agressiveOrderIndicator,
      orderType,
    );
    setSelectedStrike(optionGridData["key"]);
    setOrderEntryData(optionGridData);
    setOrderEntryData_Live(optionGridData);
    setIsOrderEntryOpenedFromMain(true);
  };

  return (
    <React.Fragment>
      <IonItem
        button
        detail={false}
        id={(() => {
          if (optionGridData["data"] && optionGridData["data"][0]) {
            if (strikePriceATM && optionGridData["data"][1]?.a === true) {
              return `focuseditem`;
            }
            if (!strikePriceATM && optionGridData["key"] == nearestStrike) {
              return `focuseditem`;
            }
          }
          return "";
        })()}
        className="ion-no-padding animate__animated animate__fadeIn animate__faster"
        lines="none"
        style={{
          "--inner-padding-end": 0,
          "--min-height": "65px",
          "--background": "none",
        }}
      >
        <div className="custom_optionsgrid_item">
          <div
            className="strike_section"
            style={{
              backgroundColor: `${
                optionGridData["data"] !== undefined &&
                optionGridData["data"][1]?.a === true
                  ? "#FF912E"
                  : "#00426d"
              } `,
            }}
            onClick={() => {
              setIsOptionsGridViewModalOpen(true);
              setSelectedStrike(optionGridData["key"]);
              setOrderEntryData(optionGridData);
              setOrderEntryData_Live(optionGridData);
              setType(selectedDerivativeType === "puts" ? "put" : "call");
            }}
          >
            {optionGridData["key"]}
          </div>
          {selectedDerivativeType == "puts" ? (
            // PUTS DATA
            <React.Fragment>
              <div
                className="bid_qty_section_optionsgrid"
                onClick={() => {
                  bidAndOfferModalDetail("bid", "put");
                }}
              >
                <div className="bid_qty_sub_section_optionsgrid">
                  <div className="optionsgrid_bid">
                    {optionGridData["data"][1] !== undefined &&
                    optionGridData["data"][1] !== null &&
                    (optionGridData["data"][1]?.b?.r !== 0 ||
                      optionGridData["data"][1]?.bb?.r !== 0)
                      ? optionGridData["data"][1]?.b !== null &&
                        optionGridData["data"][1]?.b?.f
                      : ""}
                  </div>
                  <div
                    className="optionsgrid_bid_qty"
                    style={
                      optionGridData["data"][1] !== undefined &&
                      optionGridData["data"][1] !== null &&
                      optionGridData["data"][1]?.bb?.r !== 0
                        ? {}
                        : { visibility: "hidden" }
                    }
                  >
                    {optionGridData["data"][1] !== undefined &&
                    optionGridData["data"][1] !== null &&
                    optionGridData["data"][1]?.bb?.r !== 0
                      ? optionGridData["data"][1]?.bb !== null &&
                        optionGridData["data"][1]?.bb?.f
                      : "0"}
                  </div>
                </div>
              </div>
              <div
                className="offer_qty_section_optionsgrid"
                onClick={() => {
                  bidAndOfferModalDetail("offer", "put");
                }}
              >
                <div className="offer_qty_sub_section_optionsgrid">
                  <div className="optionsgrid_offer">
                    {optionGridData["data"][1] !== undefined &&
                    optionGridData["data"][1] !== null &&
                    (optionGridData["data"][1]?.bo?.r !== 0 ||
                      optionGridData["data"][1]?.boq?.r !== 0)
                      ? optionGridData["data"][1]?.bo !== null &&
                        optionGridData["data"][1]?.bo?.f
                      : ""}
                  </div>
                  <div
                    className="optionsgrid_offer_qty"
                    style={
                      optionGridData["data"][1] !== undefined &&
                      optionGridData["data"][1] !== null &&
                      optionGridData["data"][1]?.boq?.r !== 0
                        ? {}
                        : { visibility: "hidden" }
                    }
                  >
                    {optionGridData["data"][1] !== undefined &&
                    optionGridData["data"][1] !== null &&
                    optionGridData["data"][1]?.boq?.r !== 0
                      ? optionGridData["data"][1]?.boq !== null &&
                        optionGridData["data"][1]?.boq?.f
                      : "0"}
                  </div>
                </div>
              </div>
              <div className="last-theo_section">
                {greeksData.length !== 1 && (
                  <div className="last">
                    {greeksData[1].l !== null ? `${greeksData[1].l.f}` : ""}
                  </div>
                )}
                {greeksData.length !== 1 && (
                  <div className="theo">
                    {greeksData[1].t2 !== null ? `${greeksData[1].t2.f}` : ""}
                  </div>
                )}
              </div>
              <div className="delta-vol_section">
                {greeksData.length !== 1 && (
                  <div className="delta">
                    {greeksData[1].d !== null ? `${greeksData[1].d.f}` : ""}
                  </div>
                )}
                {greeksData.length !== 1 && (
                  <div className="vol">
                    {greeksData[1].v !== null ? `${greeksData[1].v.f}` : ""}
                  </div>
                )}
              </div>
            </React.Fragment>
          ) : (
            // CALLS DATA
            <React.Fragment>
              <div className="bid_qty_section_optionsgrid">
                <div
                  className="bid_qty_sub_section_optionsgrid"
                  onClick={() => {
                    bidAndOfferModalDetail("bid", "call");
                  }}
                >
                  <div className="optionsgrid_bid">
                    {optionGridData["data"][0] !== undefined &&
                    optionGridData["data"][0] !== null &&
                    (optionGridData["data"][0]?.b?.r !== 0 ||
                      optionGridData["data"][0]?.bb?.r !== 0)
                      ? optionGridData["data"][0]?.b !== null &&
                        optionGridData["data"][0]?.b?.f
                      : ""}
                  </div>
                  <div
                    className="optionsgrid_bid_qty"
                    style={
                      optionGridData["data"][0] !== undefined &&
                      optionGridData["data"][0] !== null &&
                      optionGridData["data"][0]?.bb?.r !== 0
                        ? {}
                        : { visibility: "hidden" }
                    }
                  >
                    {optionGridData["data"][0] !== undefined &&
                    optionGridData["data"][0] !== null &&
                    optionGridData["data"][0]?.bb?.r !== 0
                      ? optionGridData["data"][0]?.bb !== null &&
                        optionGridData["data"][0]?.bb?.f
                      : "0"}
                  </div>
                </div>
              </div>
              <div
                className="offer_qty_section_optionsgrid"
                onClick={() => {
                  bidAndOfferModalDetail("offer", "call");
                }}
              >
                <div className="offer_qty_sub_section_optionsgrid">
                  <div className="optionsgrid_offer">
                    {optionGridData["data"][0] !== undefined &&
                    optionGridData["data"][0] !== null &&
                    (optionGridData["data"][0]?.bo?.r !== 0 ||
                      optionGridData["data"][0]?.boq?.r !== 0)
                      ? optionGridData["data"][0]?.bo !== null &&
                        optionGridData["data"][0]?.bo?.f
                      : ""}
                  </div>
                  <div
                    className="optionsgrid_offer_qty"
                    style={
                      optionGridData["data"][0] !== undefined &&
                      optionGridData["data"][0] !== null &&
                      optionGridData["data"][0]?.boq?.r !== 0
                        ? {}
                        : { visibility: "hidden" }
                    }
                  >
                    {optionGridData["data"][0] !== undefined &&
                    optionGridData["data"][0] !== null &&
                    optionGridData["data"][0]?.boq?.r !== 0
                      ? optionGridData["data"][0]?.boq !== null &&
                        optionGridData["data"][0]?.boq?.f
                      : "0"}
                  </div>
                </div>
              </div>
              <div className="last-theo_section">
                {greeksData.length !== 1 && (
                  <div className="last">
                    {greeksData[0].l !== null ? `${greeksData[0].l.f}` : ""}
                  </div>
                )}
                {greeksData.length !== 1 && (
                  <div className="theo">
                    {greeksData[0].t2 !== null ? `${greeksData[0].t2.f}` : ""}
                  </div>
                )}
              </div>
              <div className="delta-vol_section">
                {greeksData.length !== 1 && (
                  <div className="delta">
                    {greeksData[0].d !== null ? `${greeksData[0].d.f}` : ""}
                  </div>
                )}
                {greeksData.length !== 1 && (
                  <div className="vol">
                    {greeksData[0].v !== null ? `${greeksData[0].v.f}` : ""}
                  </div>
                )}
              </div>
            </React.Fragment>
          )}
        </div>
      </IonItem>
    </React.Fragment>
  );
};

export default OptionsGridListItem;
